import { useContext, useEffect, useState } from "react";
import { getPropertySurrounding } from "./house-service";
import { HousePropertySurroundings } from "./types";
import { HouseCompetitionData } from "./contextProvider";
import Skeleton from "react-loading-skeleton";
import DOMPurify from "dompurify";

const PropertySurroundings = () => {
  const [surroundingsData, setSurroundingsData] = useState<string>("");
  const { prizeId } = useContext(HouseCompetitionData);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (prizeId) {
      getSurroundings();
    }
  }, [prizeId]);

  const getSurroundings = async () => {
    try {
      const response = await getPropertySurrounding(prizeId);
      const { HousePropertySurrounding } = (await response.json()) as HousePropertySurroundings;
      setSurroundingsData(HousePropertySurrounding);
    } catch (error) {
      console.error("Error fetching surroundings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Skeleton inline highlightColor="#fff" height={250} containerClassName="w-full bg-[#f1f1f1]" />
  ) : (
    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(surroundingsData) }} />
  );
};

export default PropertySurroundings;
